import { CompareMaterialsRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const compareRoute = {
  path: 'compare',
  element: <CompareMaterialsRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Compare Materials</span>,
  })
};